import type { TableFilter } from 'src/generated/graphql';

interface ColumnWidth {
  [columnId: string]: number;
}

interface TableState {
  [tableId: string]: {
    columnsWidth: ColumnWidth;
  };
}

interface BoardColumnWidthState {
  [boardId: string]: TableState;
}

export type TableViewHeader = {
  sortBy: { column: string; direction: string }[];
  groupBy: string;
  filter: TableFilter;
};

interface TableViewState {
  [viewId: string]: TableViewHeader;
}

interface TableViewHeaderState {
  [boardId: string]: TableViewState;
}

export interface BoardPersistUIState {
  boardsColumnWidth: BoardColumnWidthState;
  setColumnWidth: (
    boardId: string,
    tableId: string,
    columnId: string,
    width: number,
  ) => void;

  tableViewHeader: TableViewHeaderState;
  setGroupBy: (boardId: string, viewId: string, groupBy: string) => void;
  setFilter: (boardId: string, viewId: string, filter: TableFilter) => void;
  setSortBy: (
    boardId: string,
    viewId: string,
    sortBy: { column: string; direction: string }[],
  ) => void;

  hideActivities: boolean;
  setBoardHideActivities: (hideActivities: boolean) => void;

  boardActivitiesWidth: number;
  setBoardActivitiesWidth: (boardActivitiesWidth: number) => void;

  hideKanbanLabels: boolean;
  setHideKanbanLabels: (hideKanbanLabels: boolean) => void;

  kanbanOnlyHeaderColor: boolean;
  setKanbanOnlyHeaderColor: (kanbanOnlyHeaderColor: boolean) => void;

  resetBoardUIState: () => void;
}

export const initialBoardColumnWidthState: BoardColumnWidthState = {};

export const initialTableViewState: TableViewHeaderState = {};

export interface ColumnWidthUIState {
  columnWidth: number;
  setColumnWidth: (width: number) => void;
}
